import React from 'react';
import styled from 'styled-components';
// @ts-ignore
import {ReactComponent as ClearIcon} from '@zendeskgarden/svg-icons/src/16/x-stroke.svg';

const StyledClearIcon = styled(ClearIcon)`
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

interface ClearButtonProps {
  onClick: () => void;
}

const ClearButton: React.FC<ClearButtonProps> = ({ onClick }) => {
    return <StyledClearIcon onClick={onClick} />;
};

export default ClearButton;